<template>
  <div>
    <h6 class="m-1">{{ $t("notification.all-notifications") }}</h6>
    <simplebar style="max-height:500px">
      <empty v-if="pagination && pagination.docs && pagination.docs.length == 0" width="200px">
        <h6 class="text-center text-muted">{{ $t("notification.empty") }}</h6>
      </empty>
      <div v-if="pagination">
        <div
          v-for="item in pagination.docs"
          :key="item._id"
          :class="{ readed: !item.readed, hand: !item.readed }"
          @click="markAsRead(item)"
          class="text-reset notification-item hider"
        >
          <div class="media">
            <div class="avatar-xs mr-3">
              <span
                v-if="item.readed"
                :class="{
                  'bg-soft-danger': item.type == 'ERROR',
                  'bg-soft-primary': item.type == 'INFO',
                  'bg-soft-success': item.type == 'SUCCESS',
                  'bg-soft-info': item.type == 'NEWS',
                }"
                class="avatar-title bg-soft-secondary rounded-circle font-size-16"
              >
                <i class="bx bx-bell"></i>
              </span>
              <span
                v-else
                :class="{
                  'bg-danger': item.type == 'ERROR',
                  'bg-primary': item.type == 'INFO',
                  'bg-success': item.type == 'SUCCESS',
                  'bg-info': item.type == 'NEWS',
                }"
                class="avatar-title bg-secondary rounded-circle font-size-16"
              >
                <i class="bx bx-bell"></i>
              </span>
            </div>

            <div class="media-body">
              <i class="bx bx-trash text-danger float-right hand hidden" @click="remove(item)"></i>

              <h6 class="mt-0 mb-1">{{ item.title | translate }}</h6>
              <div class="font-size-12 text-muted">
                <p v-if="item.message" class="mb-1">{{ item.message | translate }}</p>
                <p class="mb-0">
                  <i class="mdi mdi-clock-outline"></i>
                  {{ item.at | date(true) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </simplebar>

    <b-pagination
      v-if="pagination && pagination.docs && pagination.docs.length > 0"
      @click.native.stop
      v-model="request.options.page"
      :total-rows="pagination.totalDocs"
      :per-page="pagination.limit"
      size="sm"
    ></b-pagination></div
></template>

<script>
import Simplebar from "simplebar-vue";

export default {
  components: { Simplebar },
  data() {
    return {
      tabIndex: 1,
      request: {
        query: {},
        options: {
          page: 1,
          limit: 20,
          sort: { at: -1 },
        },
      },
    };
  },
  computed: {
    unreads() {
      return this.pagination?.docs?.filter((i) => !i.readed) ?? [];
    },
    pagination() {
      return this.$store.getters["workspaceNotification/pagination"];
    },
    selectedWorkspace() {
      return this.$store.getters["switchWorkspace/selected"];
    },
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
  },

  mounted() {},
  methods: {
    paginate() {
      if (this.selectedWorkspace) {
        this.$store.dispatch("workspaceNotification/paginate", this.request);
      }
    },
    async remove(item) {
      await this.$store.dispatch("workspaceNotification/remove", item);
      this.paginate();
    },
    async markAsRead(item) {
      if (item.readed) return;
      await this.$store.dispatch("workspaceNotification/markAsRead", item);
      this.paginate();
    },
    async markAsReadAll() {
      await this.$store.dispatch("workspaceNotification/markAsReadAll");
      this.paginate();
    },
  },
};
</script>

<style scoped>
.readed {
  background-color: rgb(237 243 249) !important;
}
.pagination {
  justify-content: center;
}
</style>
